import { Outlet as BaseOutlet, OutletProps } from "react-router";
import Suspense from "./Suspense";
import ErrorBoundary from "./ErrorBoundary";

interface Props extends OutletProps {}

export default function Outlet(props: Props) {
  return (
    <ErrorBoundary>
      <Suspense>
        <BaseOutlet {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}
